import api from './api'
import { get, post } from './http'

const request = {}
// 这些字段是请求工厂保留字段，只参与前端请求行为控制，不能作为业务 payload 字段名使用。
// 新代码优先通过第三个参数传入，例如 request.xxx(payload, [], { noloading: true, signal })。
const RUNTIME_OPTION_KEYS = ['noloading', 'timeout', 'headers', 'signal']

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

// 兼容两种调用方式：
// 1. 旧写法：request.xxx({ noloading: true }, pathArray)
// 2. 新写法：request.xxx(params, pathArray, { noloading: true })
// 最终统一把控制字段从真实业务参数里剥离出来。
function extractRuntimeOptions(params = {}, runtimeOptions = {}) {
  const requestParams = isPlainObject(params) ? { ...params } : params
  const mergedRuntimeOptions = {
    ...(isPlainObject(runtimeOptions) ? runtimeOptions : {})
  }

  if (!isPlainObject(requestParams)) {
    return {
      params: requestParams,
      runtimeOptions: mergedRuntimeOptions
    }
  }

  RUNTIME_OPTION_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(requestParams, key)) {
      if (!Object.prototype.hasOwnProperty.call(mergedRuntimeOptions, key)) {
        mergedRuntimeOptions[key] = requestParams[key]
      }
      delete requestParams[key]
    }
  })

  return {
    params: requestParams,
    runtimeOptions: mergedRuntimeOptions
  }
}

// 路径段按 segment 单独编码，避免 taskId / fileName 含空格、斜杠或中文时拼接出错。
function encodePathSegments(pathArray = []) {
  if (!Array.isArray(pathArray) || pathArray.length === 0) {
    return ''
  }

  return pathArray
    .map((segment) => encodeURIComponent(String(segment)))
    .join('/')
}

Object.keys(api).forEach((key) => {
  request[key] = request[key] || {}
  api[key].forEach((item) => {
    const { url, method, headers } = item.base
    const requestHandler = (params = {}, pathArray = [], runtimeOptions = {}) => {
      const { params: requestParams, runtimeOptions: mergedRuntimeOptions } = extractRuntimeOptions(params, runtimeOptions)
      const config = {
        ...(item.config || {}),
        ...mergedRuntimeOptions
      }
      const requestHeaders = {
        ...(headers || {}),
        ...(config.headers || {})
      }

      const fullUrl = `${url}${encodePathSegments(pathArray)}`

      if (method === 'post') {
        return post(fullUrl, requestParams, config, requestHeaders)
      }

      // 默认是 get
      return get(fullUrl, requestParams, config, requestHeaders)
    }

    request[key][item.name] = requestHandler

    // API 改名时通过 aliases 保留旧入口，先让调用方平滑迁移，
    // 避免一次性清理把历史代码全部打断。
    if (Array.isArray(item.aliases)) {
      item.aliases.forEach((aliasName) => {
        if (!aliasName || request[key][aliasName]) {
          return
        }

        request[key][aliasName] = requestHandler
      })
    }
  })
})

export default request
